/* eslint-disable @typescript-eslint/naming-convention */
export enum DeviceDbLevel {
	dB3 = 'dB3',
	dB6 = 'dB6',
	dB9 = 'db9'
}

export type DeviceDbLevels = undefined | { [level in DeviceDbLevel]: number };
